import { create } from "zustand";

import {
  getCheckout, selectShippingMethod,
  setCheckoutAddress,
} from "../services/checkoutApi";

export const useCheckoutStore = create((set, get) => ({
  shipments: [],
  destinationAddress: null,
  selectedMethods: {},

  loading: false,
  error: null,

  updatingAddress: false,
  setDestinationAddress: (address) => set({ destinationAddress: address }),

  fetchCheckout: async () => {

  set({ loading: true });

  try {

    const data = await getCheckout();

    const selectedMethods = {};

    data.shipments.forEach((shipment) => {
      if (shipment.selected_option) {
        selectedMethods[shipment.id] = shipment.selected_option.id;
      }
    });

    set({
      shipments: data.shipments,
      destinationAddress: data.destination_address,
      selectedMethods: selectedMethods,
    });

  } catch (err) {
    console.error(err);
  } finally {
    set({ loading: false });
  }
},


  updateAddress: async (address) => {
    set({updatingAddress: true, error: null});

    try {
      await setCheckoutAddress(address.id);
      await get().fetchCheckout();
      set({destinationAddress: address});
    } catch (err) {
      console.error(err);
      set({error: "خطا در ثبت آدرس تحویل"});
      throw err;
    } finally {
      set({updatingAddress: false});
    }
  },

    selectMethod: async (shipmentId, option) => {
    // ذخیره مقدار قبلی برای بازگردانی در صورت خطا (Rollback)
    const previousMethods = get().selectedMethods;

    // ۱. آپدیت خوش‌بینانه (Optimistic Update)
    set((state) => ({
      selectedMethods: {
        ...state.selectedMethods,
        [shipmentId]: option.id,
      },
    }));

    try {
      // ۲. فراخوانی API
      await selectShippingMethod(shipmentId, option.id)
      // ۳. به‌روزرسانی نهایی استیت از سرور
      await get().fetchCheckout();

    } catch (err) {
      console.error("Error setting shipping method:", err);
      set({error: "خطا در انتخاب روش ارسال"});

      // ۴. بازگردانی استیت به حالت قبل در صورت خطا
      set({ selectedMethods: previousMethods });

      throw err; // یا می‌توان alert را اینجا گذاشت
    }
  },

}));